
<div>
  <div class="card">
    <mat-card>
      <div class="row">
        <div class="" style="width: 20%; padding-left: 20px;"></div>
        <div class="col-md-6">
          <div class="card">

            <div class="card-header" style="background-image: url(../assets/images/Header_BG.jpg);">
              <div class="panel-heading" style="color:#ffffff;" title="STAFF MAINTENANCE">
                <div class="" tabindex="0" title="Add New Staff Member" aria-label="Staff Member">
                  {{action}} Staff Member
                  <button type="button" class="close" aria-label="Close" (click)="CloseStaffMember()">
                    <span title="Close" style="color: white; height:34px;float: right;"
                      aria-hidden="true">&times;</span>
                  </button>
                </div>
              </div>

            </div>

            <form class="form-horizontal">
              <div>
                <div class="card-body">
                  <div tabindex="0">
                    <p title="Fields marked with (*) are required."
                      style="color:crimson; font-size:13px;font-style:italic;text-align:left">Fields
                      marked
                      with (*) are required.</p>
                  </div>
                  <form class="form-horizontal">
                    <div>


                      <div class="form-group row">
                        <label tabindex="0" title="Last Name" aria-label="Last Name"
                          class="col-md-3 form-control-label">Last
                          Name<span class="j-color">*</span>
                        </label>
                        <div class="col-md-5">
                          <input type="text" name="Last Name" tabindex="0" title="{{staffLastname}}"
                            aria-label="Last Name" [(ngModel)]="staffLastname" class="form-control">

                        </div>
                      </div>
                      <div class="form-group row">
                        <label tabindex="0" title="First Name" aria-label="First Name"
                          class="col-md-3 form-control-label">First Name<span class="j-color">*</span>
                        </label>
                        <div class="col-md-5">
                          <input type="text" name="First Name" tabindex="0" title="{{staffFirstname}}"
                            aria-label="First Name" [(ngModel)]="staffFirstname" class="form-control">

                        </div>
                      </div>
                      <div>
                        <div class="form-group row">
                          <label tabindex="0" title="Staff Email" aria-label="Staff Email"
                            class="col-md-3 form-control-label">Staff Email<span class="j-color">*</span>
                          </label>
                          <div class="col-md-5">
                            <input type="text" tabindex="0" title="{{staffEmail}}" aria-label="Staff Email" name="Email"
                              [(ngModel)]="staffEmail" class="form-control">
                          </div>
                        </div>
                        <div class="form-group row">
                          <label tabindex="0" title="Staff Group" aria-label="Staff Group"
                            class="col-md-3 form-control-label">Staff Group<span class="j-color">*</span>

                          </label>
                          <div class="col-md-5">
                            <select class="form-control" name="UserRole" [(ngModel)]="isstaffGroup" tabindex="0"
                              title="Staff Group" aria-label="Click here to select Staff Group">
                              <option value="0">Select</option>
                              <option *ngFor="let role of Userroles" [attr.value]="role.RoleId" [ngValue]="role.RoleId">
                                {{role.RoleName}}</option>
                            </select>

                          </div>
                        </div>
                        <div class="form-group row">
                          <label class="col-md-3 form-control-label" tabindex="0" title="Active "
                            aria-label="Active ">Active
                          </label>
                          <div class="col-md-6">
                            <input type="checkbox" aria-label="Active" style="width:20px;height:20px;"
                              [(ngModel)]="isstaffActive" [ngModelOptions]="{standalone: true}" />
                          </div>
                        </div>
                        <div class="form-group row">
                          <div class="col-md-6" style="color:crimson;" tabindex="0">
                            {{message}}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div>
                      <div class="form-group row">
                        <div class="col-sm-3"></div>
                        <div class="col-sm-6" style="white-space:nowrap">
                          <button id="btnClearMD" type="submit" class="btn btn-info" tabindex="0" title="Clear"
                            style="background-color:#0a4879;" aria-label="Clear"
                            (click)="ClearStaffMember()">Clear</button>
                          &nbsp;
                          <button id="btnSaveMD" type="submit" class="btn btn-info" tabindex="0" title="Save"
                            style="background-color:#0a4879;" aria-label="Save" (click)="SaveUser()">Save</button>
                          &nbsp;

                          <button id="btnCloseMD" type="submit" class="btn btn-info" tabindex="0" title="Close"
                            style="background-color:#0a4879;" aria-label="Close"
                            (click)="CloseStaffMember()">Close</button>
                        </div>
                      </div>
                      <br />
                    </div>
                  </form>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

    </mat-card>
  </div>
</div>
